<section class="row invoices c-list-orders" id="productList-area">
  <aside class="col-md-4 col-lg-3 invoice-filter pr-0 my-4">
    <div class="c-list-orders--aside">
      <fieldset
        [ngClass]="{ 'd-none': hideFilter }"
        class="d-none d-md-block mb-4 mb-md-0"
        id="filter-by"
      >
        <h2 class="c-text c-heading-h3 u-border-bottom-grey pb-3 mb-0">
          {{ 'invoiceCredit.searchBy' | cxTranslate }}
        </h2>
        <!-- Timeframe -->
        <div class="filterByGroup mb-3 c-text-input mt-4">
          <h5 class="c-text c-heading-h3 mb-2 mt-4">
            {{ 'invoiceCredit.timeFrame' | cxTranslate }}
          </h5>
          <ng-select
            name="timeFrame"
            [items]="timeFrameList"
            [searchable]="false"
            [clearable]="false"
            bindLabel="name"
            bindValue="code"
            class="c-select ng-select pull-left"
            (ngModelChange)="clearDateRange()"
            [(ngModel)]="timeFrame"
            placeholder="{{ 'invoiceCredit.timeFrame' | cxTranslate }}"
          >
          </ng-select>
        </div>
        <!--Date Range-->
        <div class="filterByGroup c-text-input mt-4">
          <h5 class="c-text c-heading-h3 mb-4" for="invoice">
            {{ 'invoiceCredit.dateRange' | cxTranslate }}
          </h5>
          <div class="delivary-details mb-4">
            <div>
              <fieldset class="form-horizontal">
                <legend class="control-group mb-2">
                  <h5
                    class="font-bold mb-0"
                    for="fromDate"
                    aria-labelledby="dataRange fromDate"
                  >
                    {{ 'invoiceCredit.from' | cxTranslate }}
                  </h5>
                </legend>
                <div class="headSearch-holder">
                  <label class="searchbox orders-filter time-frame">
                    <!-- <img src="../../../assets/icons/calendar.svg" alt="" /> -->
                    <input
                      type="text"
                      placeholder="{{
                        'invoiceCredit.dateFormat' | cxTranslate
                      }}"
                      class="input-filter"
                      [(ngModel)]="fromDate"
                      (ngModelChange)="validateDate()"
                      bsDatepicker
                      [maxDate]="maxSelectionDate"
                      [daysDisabled]="[0, 6]"
                      [bsConfig]="{
                        containerClass: 'order-list-date',
                        dateInputFormat: dateFormat
                      }"
                      (click)="clearToDate()"
                    />
                  </label>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="delivery-details">
            <div>
              <fieldset class="form-horizontal mb0">
                <legend class="control-group mb-2">
                  <h5
                    class="font-bold mb-0"
                    for="toDate"
                    aria-labelledby="dataRange toDate"
                  >
                    {{ 'invoiceCredit.to' | cxTranslate }}
                  </h5>
                </legend>
                <div class="headSearch-holder">
                  <label class="searchbox orders-filter time-frame">
                    <!-- <img src="../../../assets/icons/calendar.svg" alt="" /> -->
                    <input
                      type="text"
                      placeholder="{{
                        'invoiceCredit.dateFormat' | cxTranslate
                      }}"
                      class="input-filter"
                      [(ngModel)]="toDate"
                      (ngModelChange)="validateDate()"
                      bsDatepicker
                      [maxDate]="maxSelectionDate"
                      [daysDisabled]="[0, 6]"
                      [bsConfig]="{
                        containerClass: 'order-list-date',
                        dateInputFormat: dateFormat
                      }"
                    />
                  </label>
                </div>
              </fieldset>
            </div>
          </div>
          <span class="text-danger" *ngIf="dateError">{{
            'ordersList.invalidDateErrMsg' | cxTranslate
          }}</span>
          <span class="text-danger" *ngIf="singleDateError">{{
            'ordersList.selectBothDate' | cxTranslate
          }}</span>
        </div>
        <!--End-->

        <!-- Invoice number -->
        <div class="filterByGroup c-text-input mt-4">
          <h5 class="c-text font-bold mb-2">
            {{ 'invoiceCredit.invoice' | cxTranslate }}
          </h5>
          <div class="headSearch-holder c-text-input--with-icon-left">
            <label class="searchbox orders-filter time-frame">
              <input
                placeholder="{{ 'invoiceCredit.search' | cxTranslate }}"
                type="text"
                autocomplete="off"
                aria-describedby="initialDescription"
                aria-controls="results"
                aria-autocomplete="both"
                class="input-filter"
                [(ngModel)]="creditOrInvoiceNumber"
              />
              <button role="presentation" class="search-icon">
                <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
              </button>
            </label>
          </div>
        </div>

        <!-- Installment number -->
        <div class="filterByGroup c-text-input mt-4">
          <h5 class="c-text font-bold mb-2">
            {{ 'invoiceCredit.instalment' | cxTranslate }}
          </h5>
          <div class="headSearch-holder c-text-input--with-icon-left">
            <div class="searchbox orders-filter time-frame">
              <input
                placeholder="{{ 'invoiceCredit.search' | cxTranslate }}"
                type="text"
                autocomplete="off"
                aria-describedby="initialDescription"
                aria-controls="results"
                aria-autocomplete="both"
                class="input-filter"
                [(ngModel)]="instalmentNumber"
              />
              <button role="presentation" class="search-icon">
                <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Status -->
        <div class="filterByGroup mb-3 c-text-input mt-4">
          <h5 class="c-text font-bold mb-2">
            {{ 'invoiceCredit.status' | cxTranslate }}
          </h5>
          <ng-select
            name="status"
            [items]="statusList"
            [searchable]="false"
            [clearable]="false"
            class="c-select ng-select pull-left"
            placeholder="{{ 'invoiceCredit.status' | cxTranslate }}"
            [(ngModel)]="selectedStatus"
          >
          </ng-select>
          <br class="d-none d-md-block" />
        </div>

        <!-- Apply / Cancel filters -->
        <div class="account-order-filter-btn">
          <button
            type="submit"
            class="c-button c-button--primary mb-4 w-100"
            data-di-id="di-id-362f2c77-5f23e741"
            (click)="applyFilter()"
            [disabled]="differenceInDaysError"
          >
            {{ 'invoiceCredit.applyFilters' | cxTranslate }}
          </button>
          <button
            type="button"
            id="clearOrderFiltersBtn"
            class="c-button c-button--secondary w-100"
            data-di-id="#clearOrderFiltersBtn"
            (click)="clearFilters()"
          >
            {{ 'invoiceCredit.clearFilters' | cxTranslate }}
          </button>
        </div>
      </fieldset>
      <button
        class="c-button c-button--secondary w-100 d-block d-md-none"
        (click)="toggleFilter()"
      >
        <ng-container *ngIf="hideFilter">{{
          'ordersList.refine' | cxTranslate
        }}</ng-container>
        <ng-container *ngIf="!hideFilter"
          >{{ 'ordersList.hide' | cxTranslate }}</ng-container
        >
      </button>
      <!-- Help section -->
      <div class="d-none d-md-block">
        <app-need-to-go-back></app-need-to-go-back>
      </div>
    </div>
  </aside>
  <section class="col-md-8 col-lg-9 pl-lg-4 my-2">
    <!-- Applied Filters -->
    <div class="d-flex justify-content-between mt-2 px-4 px-lg-0">
      <div class="text-fixed-medium d-flex gap-05 align-items-center flex-wrap">
        {{ 'ordersList.filtersApplied' | cxTranslate }}
        <span *ngIf="!facetsList.length">
          {{ 'ordersList.none' | cxTranslate }}
        </span>
        <span *ngFor="let filter of facetsList">
          <button
            type="button"
            *ngIf="facetsList.length"
            class="c-button c-button--primary c-button--with-icon c-button--chips"
            (click)="removeFacet(filter)"
          >
            <em class="fa fa-times-circle" aria-hidden="true"></em>
            {{ filter.value }}
          </button>
        </span>
        <button
          type="button"
          *ngIf="facetsList.length"
          class="c-button c-button--link-primary ml-1"
          (click)="clearFilters()"
        >
          {{ 'ordersList.clearAllFilters' | cxTranslate }}
        </button>
      </div>
    </div>
    <br />

    @if (invoicesLoading) {
      <app-loader/>
    } @else {
      <section class="c-table-flex-four-col my-4 pb-0 pb-md-4">
        <!-- No Results after filter -->
        <section class="py-4" *ngIf="!paymentList || paymentList.length == 0">
          <h2 class="c-text c-heading-h3 ml-3 ml-md-2 my-2 pb-4">
            {{ 'invoiceCredit.no_open_invoices' | cxTranslate }}
          </h2>
        </section>
        <!-- table -->
        <div
          class="c-table-flex-four-col-container c-table-flex-four-col-container-head d-none d-md-flex"
          *ngIf="paymentList && paymentList.length >= 1"
        >
          <div
            class="c-table-flex-four-col-item"
            (click)="sortColumn($event, 'docNo', paymentList, 'normal')"
          >
            {{ 'invoiceCredit.invoice' | cxTranslate }}&nbsp;<i
            class="my-icon fas fa-caret-down"
          ></i>
          </div>
          <div
            class="c-table-flex-four-col-item"
            (click)="sortColumn($event, 'blineDate', paymentList, 'Date')"
          >
            {{ 'invoiceCredit.invoice_date' | cxTranslate }}&nbsp;<i
            class="my-icon fas fa-caret-down"
          ></i>
          </div>
          <div
            class="c-table-flex-four-col-item"
            (click)="sortColumn($event, 'dueDate', paymentList, 'Date')"
          >
            {{ 'invoiceCredit.due_date' | cxTranslate }}&nbsp;<i
            class="my-icon fas fa-caret-down"
          ></i>
          </div>
          <div
            class="c-table-flex-four-col-item"
            (click)="sortColumn($event, 'amount', paymentList, 'Number')"
          >
            {{ 'invoiceCredit.invoice_balance' | cxTranslate }}&nbsp;<i
            class="my-icon fas fa-caret-down"
          ></i>
          </div>
        </div>
        <div
          class="c-table-flex-four-col-container c-table-flex-four-col-container-body"
          *ngFor="let data of paymentList; let i = index"
        >
          <div class="c-table-flex-four-col-item-container">
            <div class="c-table-flex-four-col-item text-left">
            <span class="font-bold d-block d-md-none">
              {{ 'makeAPayment.invoice#' | cxTranslate }}
            </span>
              <span>
              {{ data.refhdr }}
            </span>
            </div>
            <div class="c-table-flex-four-col-item text-left">
            <span class="font-bold d-block d-md-none">
              {{ 'makeAPayment.invoice_date' | cxTranslate }}
            </span>
              {{ data.docDate }}
            </div>
            <div class="c-table-flex-four-col-item text-left">
            <span class="font-bold d-block d-md-none">
              {{ 'makeAPayment.due_date' | cxTranslate }}
            </span>
              <span
                [ngClass]="
                !!data.dueDate && dateComparison(data.dueDate)
                  ? 'red text-danger'
                  : ''
              "
              >{{ data.dueDate }}
                <ng-template #popSaveContent>
                {{ 'makeAPayment.past_due_date' | cxTranslate }}
              </ng-template>
              <span
                [ngbPopover]="popSaveContent"
                triggers="manual"
                #p1="ngbPopover"
                placement="top"
                (click)="toggle(p1)"
                container="body"
                popoverClass="popover-black"
                *ngIf="!!data.dueDate && dateComparison(data.dueDate)"
                class="popover-trigger-icon"
              >
                <img
                  src="icons/warning_red.png"
                  alt="warningIcon"
                  class="warningIconEvent cursor-pointer"
                />
              </span>
            </span>
            </div>
            <div class="c-table-flex-four-col-item text-left">
            <span class="font-bold d-block d-md-none">
              {{ 'makeAPayment.invoice_balance' | cxTranslate }}
            </span>
              {{ data.amount | localCurrency }}
            </div>
          </div>
          <div
            class="c-table-flex-four-col-container-body-chevron"
            (click)="expandItem($event)"
          >
            <em class="c-icon fas fa-angle-down"></em>
          </div>
          <!-- Expanded item -->
          <div class="c-table-flex-four-col-item-expand d-none">
            <div class="d-flex row">
              <div class="col-md-4 mb-4">
                {{ 'invoiceCredit.enterprise' | cxTranslate }}
                <br />
                <div class="font-bold mt-2">{{ data?.company }}</div>
              </div>
              <div class="col-md-4 mb-4">
                {{ 'invoiceCredit.bank' | cxTranslate }}
                <br />
                <div class="font-bold mt-2">Santander</div>
              </div>
              <div class="col-md-4 mb-4">
                {{ 'invoiceCredit.bankUrl' | cxTranslate }}
                <br />
                <a *ngIf="data?.bankUrl"
                   class="font-bold mt-2"
                   [href]="data?.bankUrl"
                   target="_blank"
                   rel="noopener noreferrer">
                  {{ data?.bankUrl }}</a>
              </div>
              <div class="col-md-4 mb-4">
                {{ 'invoiceCredit.instalmentNumber' | cxTranslate }}
                <br />
                <div class="font-bold mt-2">{{ data?.itemNum }}</div>
              </div>
              <div class="col-md-4 mb-4">
                {{ 'invoiceCredit.payerTaxId' | cxTranslate }}
                <br />
                <div class="font-bold mt-2">{{ data?.cnpjPayer }}</div>
              </div>
              <div class="col-md-4 mb-4">
                {{ 'invoiceCredit.senderTaxId' | cxTranslate }}
                <br />
                <div class="font-bold mt-2">{{ data?.cnpjBeneficiary }}</div>
              </div>


              <div class="col-md-4 mb-4 mb-md-0">
                {{ 'invoiceCredit.ourBankNumber' | cxTranslate }}
                <br />
                <div class="font-bold mt-2">{{ data?.bankReferenceKey }}</div>
              </div>
              <div class="col-md-4 mb-4 mb-md-0">
                {{ 'invoiceCredit.fieldKeyAccess' | cxTranslate }}
                <br />
                <div class="font-bold mt-2">
                  <a href="https://www.nfe.fazenda.gov.br/PORTAL/consultaRecaptcha.aspx?tipoConsulta=resumo&tipoConteudo=7PhJ%20gAVw2g=" target="_blank">{{ data?.accessKey }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    }
  </section>
  <!-- Help section for mobile-->
  <div class="col-md-12 d-block d-md-none mb-4" *ngIf="!noInvoices">
    <div class="d-block d-md-none">
      <app-need-to-go-back></app-need-to-go-back>
    </div>
  </div>
</section>
